import React from 'react';
import { PageHeader } from 'antd';
import './style.css';
import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const Header = ({
  title,
  onBack,
  onHomeClick,
  hideBackButton = false,
  hideHomeButton = false,
}: {
  title: string;
  onBack?: () => void;
  onHomeClick?: () => void;
  hideBackButton?: boolean;
  hideHomeButton?: boolean;
}) => {
  const navigate = useNavigate();
  const defaultOnBack = () => {
    navigate(-1);
  };
  const defaultOnHomeClick = () => {
    navigate('/');
  };
  return (
    <PageHeader
      title={<p className="site-header-title">{title}</p>}
      backIcon={
        !hideBackButton ? (
          <ArrowLeftOutlined style={{ color: 'white' }} />
        ) : null
      }
      onBack={onBack ?? defaultOnBack}
      extra={
        hideHomeButton ? null : (
          <HomeOutlined
            className="text-2xl mt-2 cursor-pointer"
            onClick={onHomeClick ?? defaultOnHomeClick}
          />
        )
      }
      className="site-header"
    />
  );
};

export default Header;
